/*
 * @Author: 王琪瑞
 * @Date: 2021-03-16 09:45:18
 * @LastEditTime: 2021-04-02 18:33:51
 * @LastEditors: 王琪瑞
 */
// 实验列表数据
import {
  CreateI, DeleteI, QueryI, UpdateI,
} from '@/interface/basicOperations';
import axios from '@/axios/api';
import { definitions } from '@/types/api';
import {
  computed, reactive, onMounted, toRaw, ref,
} from 'vue';
import moment, { Moment } from 'moment';
import validate from '@/lib/validate';
import { message } from 'ant-design-vue';
import { MessageApi } from 'ant-design-vue/lib/message';
import { Class } from '@/views/Teacher/userManager/js/classModule';
import commonStore from '@/store/common';
import { QueryExperimentI, DeleteExperimentI, ExperimentDataI } from './interface';

/**
 * 实验列表查询
 * @param reqData 查询参数
 * @returns
 */
const getExperimentList = async (
  reqData: QueryExperimentI,
): Promise<definitions['Page«Experiment»']> => {
  const { data } = (
    await axios.queryExperimentByTeacher(reqData.pageSize, reqData.pageNo, reqData.teacher)
  ).data;
  return data;
};

// 延续实验内容
const getUnitForContinue = (caseUnit?: string, experimentUnit?: string): string => {
  const caseUnitArr = caseUnit ? JSON.parse(caseUnit) : [];
  const experimentUnitArr = experimentUnit ? JSON.parse(experimentUnit) : [];
  const i = caseUnitArr.indexOf(experimentUnitArr[experimentUnitArr.length - 1]) || -1;
  // console.log(caseUnitArr, experimentUnitArr, i, 'getUnitForContinue');
  caseUnitArr.splice(0, i + 1);
  // console.log(caseUnitArr, experimentUnitArr, i, 'getUnitForContinue');
  return JSON.stringify(caseUnitArr);
};
/**
 * 实验列表转换
 * @param reqData 查询参数
 * @returns
 */
const formatExperimentList = async (reqData: QueryExperimentI) => {
  const { list, totalRecords } = await getExperimentList(reqData);

  const ExperimentList = list?.map((item) => ({
    ...item,
    classIds: item.classId?.split(','),
    continue: getUnitForContinue(item.caseUnit, item.experimentalUnits) === '[]',
  }));

  return {
    ExperimentList: ExperimentList || [],
    totalRecords,
  };
};

export interface ExperimentI
  extends CreateI<definitions['Experiment'], definitions['Experiment']>,
    DeleteI<DeleteExperimentI, boolean>,
    UpdateI<definitions['Experiment'], definitions['Experiment']>,
    QueryI<unknown, definitions['Experiment'][]> {
  totalRecords: number;

  /**
   * 实验列表
   */
  list: ExperimentDataI[];
}

export class Experiment implements ExperimentI {
  totalRecords = 0;

  list: definitions['Experiment'][] = [];

  // eslint-disable-next-line class-methods-use-this
  async create(reqData: definitions['Experiment']): Promise<definitions['Experiment']> {
    try {
      const { experimentalUnits: unit } = reqData;
      const experimentalUnits = [];
      const max = Math.max(...JSON.parse(unit as string));
      for (let i = 0; i <= max; i += 1) {
        experimentalUnits.push(i);
      }
      console.log(experimentalUnits, 'experimentalUnits', JSON.parse(JSON.stringify(toRaw(reqData))));
      const parData = { ...reqData, experimentalUnits: JSON.stringify(experimentalUnits) };
      const { data } = await (await axios.editExperiment(parData)).data;
      return data;
    } catch (err) {
      throw new Error(err);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async query(reqData: QueryExperimentI): Promise<definitions['Experiment'][]> {
    try {
      const { ExperimentList, totalRecords } = await formatExperimentList(reqData);
      this.list = ExperimentList || [];
      this.totalRecords = totalRecords || 0;
      return this.list;
    } catch (err) {
      throw new Error(err);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async update(reqData: definitions['Experiment']): Promise<definitions['Experiment']> {
    try {
      const { data } = await (await axios.editExperiment(reqData)).data;
      return data;
    } catch (err) {
      throw new Error(err);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(reqData: DeleteExperimentI): Promise<boolean> {
    try {
      await axios.deleteExperimentByIds(reqData);
      return true;
    } catch (err) {
      throw new Error(err);
    }
  }
}

const editFormRules = {
  classId: [{ required: true, message: '请选择班级！' }],
  experimentName: [{ required: true, message: '请输入实验名称！' }],
};

export default (Message: MessageApi = message) => {
  // 实验
  const experimentModule = reactive(new Experiment());

  // 班级
  const classModule = reactive(new Class());

  // 分页
  const pagination = reactive({
    pageSize: 12,
    pageNo: 1,
    teacher: commonStore.getState().code,
  });

  const columns = [
    {
      title: '案例名称',
      dataIndex: 'caseName',
      key: 'caseName',
      align: 'center',
      // ellipsis: true,
    },
    {
      title: '实验名称',
      dataIndex: 'experimentName',
      key: 'experimentName',
      align: 'center',
      // ellipsis: true,
    },
    {
      title: '分配时间',
      dataIndex: 'createTime',
      key: 'createTime',
      align: 'center',
      // ellipsis: true,
    },
    {
      title: '实验信息',
      // dataIndex: 'experimentModel',
      key: 'experimentModel',
      align: 'center',
      slots: { customRender: 'experimentModel' },
    },
    {
      title: '实验班级',
      // dataIndex: 'classId',
      key: 'classId',
      align: 'center',
      slots: { customRender: 'classId' },
    },
    {
      title: '实验状态',
      // dataIndex: 'status',
      key: 'status',
      align: 'center',
      slots: { customRender: 'status' },
    },
    {
      // title: '操作',
      dataIndex: 'operation',
      align: 'center',
      slots: { customRender: 'operation', title: 'operationTitle' },
    },
  ];

  // 弹窗 显示
  const modalVisible = reactive({
    edit: false, // 分配
    delete: false, // 删除
    finish: false, // 提前结束
    continue: false, // 延续
  });

  // loading
  const modalConfirmLoading = reactive({
    edit: false,
    delete: false,
    finish: false,
  });

  // 分配表单 实验单元初始数据
  const unitList: string[] = [
    '风险分析研判',
    '推演对象分析',
    '情景任务清单',
    '应急能力评估',
    '推演方案评估',
    '推演方案制定',
    '演练结果复盘',
    '应急预案优化',
  ];

  // 分配表单 初始数据
  const initialEditForm: definitions['Experiment'] = {
    beginTime: '',
    endTime: '',
    caseId: '',
    classId: '',
    experimentModel: 1,
    experimentName: '',
    experimentalUnits: '[]',
    parentId: '',
    status: 0,
    teacher: commonStore.getState().code,
  };

  // 分配表单 表单
  const editForm: definitions['Experiment'] = reactive({ ...initialEditForm });
  /**
   * 分配-内容的状态控制
   * 点开分配框需要重置都可选，延续分配则需要判断unit
   */
  const editFormUnitState = ref([0]);
  const unitUnitState = () => {
    editFormUnitState.value = [0];
  };
  // 获得可延续index
  const getContinueIndex = () => {
    // console.log(toRaw(editForm), 'id');
    // console.log(Math.min(...editFormUnitState.value) || 1, 'Math.min(...editFormUnitState.value) || 1 ');
    // 如果有parentid，表示是延续，需要判断 0
    if (editForm.parentId) {
      return Math.min(...editFormUnitState.value) || 1;
    }
    return Math.min(...editFormUnitState.value);
  };
  const getStartIndex = () => {
    // 如果有parentid，表示是延续，需要判断 0
    if (editForm.parentId) {
      return (Math.min(...editFormUnitState.value) || 1) - 1;
    }
    return 0;
  };

  // 分配表单 案例暂留
  const caseItem: definitions['CustomCase'] = reactive({});

  // 分配表单 实验单元列表
  const unitShowList = computed(() => {
    const arr = caseItem.caseUnit
      ? JSON.parse(caseItem.caseUnit).map((e: number) => unitList[e])
      : [];
    return arr;
  });

  // 显示班级名称
  const showClassName = (id: string) => {
    const classItem = classModule.list.find((e) => e.id === id) || { name: '' };
    return classItem.name;
  };

  // 班级选择
  const checkChange = (classIds: string[]) => {
    editForm.classId = classIds.toString();
  };

  // 显示实验内容
  const showExperimentUnit = (units: string) => {
    try {
      // console.log(JSON.parse(units), unitList, 'units');
      let str = '';
      let arr = [];
      if (units) {
        str = JSON.parse(units);
        // console.log(JSON.parse(units), 'JSON.parse(units)');
        if (typeof str === 'string') {
          arr = JSON.parse(str);
        } else {
          arr = str;
        }
      }
      arr = arr.map((e: number) => unitList[e]);
      // const arr = units ? JSON.parse(units).map((e: number) => unitList[e]) : [];
      const text = arr.length ? arr.toString() : '';
      return text;
    } catch (err) {
      console.log(err);
      return '';
      // throw new Error(err);
    }
  };

  // 内容选择
  const unitChange = (value: number) => {
    editForm.experimentalUnits = caseItem.caseUnit
      ? JSON.stringify(JSON.parse(caseItem.caseUnit).slice(0, value + 1))
      : '[]';
    // console.log(editForm.experimentalUnits, 'ss');
  };

  // 日期选择
  const dateTime = reactive([]);

  const dateOk = (value: [string, string]) => {
    // console.log(value);
    [editForm.beginTime, editForm.endTime] = value;
    // console.log(editForm);
  };

  const disabledDate = (current: Moment) => current && current < moment().startOf('day');

  const range = (start: number, end: number) => {
    const result = [];

    for (let i = start; i < end; i += 1) {
      result.push(i);
    }

    return result;
  };

  const checkPickerTime = (start: string, end: string) => {
    if (new Date(end).getTime() < new Date().getTime()) {
      Message.warning('结束时间要大于当前时间！');
      return false;
    }
    if (new Date(start).getTime() > new Date(end).getTime()) {
      Message.warning('开始时间要小于结束时间！');
      return false;
    }
    return true;
  };
  /** picker的禁用——用处不大 */
  const disabledRangeTime = (_: Moment[], type: 'start' | 'end') => {
    const h = new Date().getHours();
    const m = new Date().getMinutes();
    const s = new Date().getSeconds();
    if (type === 'start') {
      return {
        disabledHours: () => range(0, 24).splice(0, h),
        disabledMinutes: () => range(0, 60).splice(0, m),
        disabledSeconds: () => range(0, 60).splice(0, s),
      };
    }
    return {};
  };

  const getDateForName = (name?: string) => {
    const time = new Date();
    const date = time.getDate().toString().length > 1 ? time.getDate().toString() : `0${time.getDate()}`;
    const month = time.getMonth().toString().length > 1
      ? (time.getMonth() + 1).toString()
      : `0${time.getMonth() + 1}`;
    const newName = `${name} ${month}${date}`;
    return newName;
  };

  // 分配弹窗 点击显示
  const handleEditClick = async (t: definitions['CustomCase']) => {
    unitUnitState();
    Object.assign(caseItem, t);
    editForm.beginTime = '';
    editForm.endTime = '';
    editForm.caseId = t.id;
    editForm.classId = '';
    editForm.experimentModel = 1;
    editForm.experimentName = getDateForName(t.caseName);
    editForm.experimentalUnits = t.caseUnit || '[]';
    editForm.parentId = '';
    editForm.status = 0;
    editForm.teacher = commonStore.getState().code;

    modalVisible.edit = true;
  };

  const handleEditCancel = () => {
    modalVisible.edit = false;
    modalVisible.continue = false;
    Object.assign(editForm, initialEditForm);
    dateTime.splice(0, dateTime.length);
  };

  const handleEditOk = async () => {
    try {
      validate(editForm, editFormRules);
      if (editForm.beginTime && editForm.endTime) {
        if (checkPickerTime(editForm.beginTime, editForm.endTime)) {
          modalConfirmLoading.edit = true;
          console.log(JSON.parse(JSON.stringify(toRaw(editForm))), 'editForm');
          await experimentModule.create(editForm);
          Message.success('分配成功');
          await experimentModule.query(pagination);
          handleEditCancel();
        }
      } else {
        Message.warning('请选择实验时间！');
      }
    } catch (err) {
      throw new Error(err);
    } finally {
      modalConfirmLoading.edit = false;
    }
  };

  // 根据案例Id查询
  const queryByCaseId = async (caseId: string): Promise<definitions['CustomCase']> => {
    try {
      const { data } = await (await axios.queryCustomCaseById(caseId)).data;
      return data;
    } catch (err) {
      throw new Error(err);
    }
  };

  // 延续分配
  const handleContinueClick = async (t: ExperimentDataI) => {
    if (t.caseId) Object.assign(caseItem, await queryByCaseId(t.caseId));

    const units = getUnitForContinue(caseItem.caseUnit, t.experimentalUnits);
    // console.log(units);
    if (units === '[]') {
      Message.warning('已分配到最后一个单元实验！');
    } else {
      editForm.experimentalUnits = units;
      editForm.beginTime = '';
      editForm.endTime = '';
      editForm.caseId = t.caseId;
      editForm.classId = t.classId;
      editForm.experimentModel = t.experimentModel;
      editForm.experimentName = getDateForName(caseItem.caseName);
      editForm.parentId = t.parentId ? t.parentId : t.id;
      editForm.status = 0;
      editForm.teacher = commonStore.getState().code;

      editFormUnitState.value = JSON.parse(units);
      modalVisible.edit = true;
      modalVisible.continue = true;
      // console.log(toRaw(editForm).experimentalUnits, JSON.parse(units), editFormUnitState.value, 'edit');
    }
  };

  // 实验id暂留
  let experimentDelId = '';

  // 删除弹窗
  const handleDeleteClick = async (id: string) => {
    experimentDelId = id;
    modalVisible.delete = true;
  };

  const handleDeleteCancel = () => {
    modalVisible.delete = false;
    experimentDelId = '';
  };

  const handleDeleteOk = async () => {
    try {
      modalConfirmLoading.delete = true;
      await experimentModule.delete({ experimentIds: [experimentDelId] });
      Message.success('删除成功');
      await experimentModule.query(pagination);
      handleDeleteCancel();
    } catch (err) {
      throw new Error(err);
    } finally {
      modalConfirmLoading.delete = false;
    }
  };

  // 提前结束
  const handleFinishClick = async (id: string) => {
    return Message.success('提前结束功能暂不可用');
    experimentDelId = id;
    // modalVisible.delete = true;
  };

  const handleFinishCancel = () => {
    modalVisible.delete = false;
    experimentDelId = '';
  };

  const handleFinishOk = async () => {
    try {
      modalConfirmLoading.finish = true;
      await experimentModule.update({ id: experimentDelId, status: 2 });
      Message.success('已结束');
      await experimentModule.query(pagination);
      handleFinishCancel();
    } catch (err) {
      throw new Error(err);
    } finally {
      modalConfirmLoading.finish = false;
    }
  };

  const handlePageChange = async () => {
    try {
      await experimentModule.query(pagination);
    } catch (err) {
      throw new Error(err);
    }
  };

  const query = async (
    pageSize: number = pagination.pageSize,
    pageNo: number = pagination.pageNo,
    teacher: string = pagination.teacher,
  ) => {
    try {
      await experimentModule.query({
        pageNo,
        pageSize,
        teacher,
      });
    } catch (err) {
      throw new Error(err);
    }
  };

  onMounted(async () => {
    await classModule.query({ pageSize: 99999, pageNo: 1 });
    await experimentModule.query(pagination);
  });

  return {
    columns,
    pagination,
    experimentModule,
    unitList,
    modalVisible,
    modalConfirmLoading,
    editForm,
    editFormUnitState,
    caseItem,
    unitShowList,
    classModule,
    dateTime,
    getContinueIndex,
    getStartIndex,
    handleContinueClick,
    handleDeleteClick,
    handleDeleteCancel,
    handleDeleteOk,
    handleFinishClick,
    handleFinishCancel,
    handleFinishOk,
    query,
    handlePageChange,
    showClassName,
    showExperimentUnit,
    handleEditClick,
    handleEditCancel,
    handleEditOk,
    disabledDate,
    disabledRangeTime,
    checkChange,
    unitChange,
    dateOk,
  };
};
